import { Component, Input, OnInit } from '@angular/core';
import { Tab } from '@ascschool/project/tabs/tab.model';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { Observable, Observer } from 'rxjs';
import { TtCaNhanComponent } from './tt-ca-nhan/tt-ca-nhan.component';
import { TrinhDoComponent } from './trinh-do/trinh-do.component';
import { HopDongComponent } from './hop-dong/hop-dong.component';
import { TtLuongComponent } from './tt-luong/tt-luong.component';
import { KhenthuongKyluatComponent } from './khenthuong-kyluat/khenthuong-kyluat.component';
import { DemoComponent } from './demo/demo.component';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { FormBuilder, Validators } from '@angular/forms';
@Component({
  selector: 'app-add-personnel',
  templateUrl: './add-personnel.component.html',
  styleUrls: ['./add-personnel.component.scss']
})
export class AddPersonnelComponent implements OnInit {
  loading = false;
  avatarUrl?: string;
  heightTab: number;
  @Input() heightBody: number;
  validateForm = this.fb.group({
    name : [null],
  });
  tabs: Tab[] = [
    new Tab( 'Thông tin cá nhân', 'ttcn', TtCaNhanComponent),
    new Tab( 'Trình độ', 'trinhDo', TrinhDoComponent),
    new Tab( 'Hợp đồng', 'hopDong', HopDongComponent),
    new Tab( 'Thông tin lương', 'ttcn', TtLuongComponent),
    new Tab( 'Khen thưởng - kỷ luật', 'ktkl', KhenthuongKyluatComponent),
    new Tab( 'Thâm niên nhà giáo', 'tnng', DemoComponent),
    new Tab( 'Quan hệ gia đình', 'qhgd', DemoComponent),
    new Tab( 'Thiết bị - thư viện', 'tbtv', DemoComponent),
    new Tab( 'Lịch sử bản thân', 'lsbt', DemoComponent),
    new Tab( 'Quan hệ thân nhân', 'qhtn', DemoComponent),
    new Tab( 'Quá trình bồi dưỡng', 'ttcn', DemoComponent),
    new Tab( 'Quá trình công tác', 'ttcn', DemoComponent),
    new Tab( 'Quá trình công tác NN', 'ttcn', DemoComponent),
    new Tab( 'Quá trình tham gia xã hội', 'ttcn', DemoComponent),
    new Tab( 'Quá trình giảng dạy', 'ttcn', DemoComponent),
    new Tab( 'Quá trình đánh giá thi đua', 'ttcn', DemoComponent),
    new Tab( 'Quá trình đào tạo', 'ttcn', DemoComponent),
    new Tab( 'Khoa học sáng kiến', 'ttcn', DemoComponent),
    new Tab( 'Tham gia lực lượng vũ trang', 'ttcn', DemoComponent),
  ];
  constructor(
    private msg: NzMessageService,
    private modal: NzModalRef,
    private fb: FormBuilder,
  ){}

  ngOnInit() {
    this.heightTab = this.heightBody;
  }

  close(e: MouseEvent) {
    e.preventDefault();
    this.destroyModal();
  }
  destroyModal(): void {
    this.modal.destroy(true);
  }
  beforeUpload = (file: NzUploadFile, _fileList: NzUploadFile[]) => {
    return new Observable((observer: Observer<boolean>) => {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        this.msg.error('You can only upload JPG file!');
        observer.complete();
        return;
      }
      const isLt2M = file.size! / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.msg.error('Image must smaller than 2MB!');
        observer.complete();
        return;
      }
      observer.next(isJpgOrPng && isLt2M);
      observer.complete();
    });
  };

  private getBase64(img: File, callback: (img: string) => void): void {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result!.toString()));
    reader.readAsDataURL(img);
  }

  handleChange(info: { file: NzUploadFile }): void {
    switch (info.file.status) {
      case 'uploading':
        this.loading = true;
        break;
      case 'done':
        // Get this url from response in real world.
        this.getBase64(info.file!.originFileObj!, (img: string) => {
          this.loading = false;
          this.avatarUrl = img;
        });
        break;
      case 'error':
        this.msg.error('Network error');
        this.loading = false;
        break;
    }
  }

  add(){
  }
}
